/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';

import Modal from '../../../../modal/modal';
import Typography from '../../../../typography/typography';
import DynamicInput from '../text';
import Button from '../../../../button/button';
import ModalLoader from '../../../../loaders/modal-loader';
import Toast from '../../../../toast/toast';
import { useTranslation } from 'react-i18next';

import {
    Box,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    Grid,
    IconButton
} from '@mui/material';
import Close from '@mui/icons-material/Close';

import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import './location-add-modal.scss';
import DynamicSearchSelect from '../dynamic-select';
interface BrandAddModalProps {
    isOpen: boolean;
    setIsOpen: () => void;
    modalProps?: DialogProps;
    onSave: (data: string) => void;
    isLoading?: boolean;
}

interface IFormValues {
    location_data: {
        name: string;
    };
}

interface IToast {
    type: 'normal' | 'alert';
    message: string;
}

const validationSchema = Yup.object().shape({
    location_data: Yup.object().shape({
        name: Yup.string().required('Name is required'),
        short_name: Yup.string().required('Short name is required'),
        company_id: Yup.number().required('Company is required')
    })
});

const LocationAddModal: React.FC<BrandAddModalProps> = ({
    isOpen,
    setIsOpen,
    modalProps,
    onSave,
    isLoading
}) => {
    const { t } = useTranslation();
    const [toast, setToast] = useState<IToast | null>(null);
    const { control, handleSubmit, reset } = useForm<any>({
        mode: 'all',
        resolver: yupResolver(validationSchema)
    });
    const handleModalClose = () => {
        reset({ location_data: undefined });
        setIsOpen();
    };

    const onSubmit = async (values: IFormValues) => {
        // handleModalClose();
        onSave(values?.location_data)
    };

    return (
        <Modal
            open={isOpen}
            onClose={handleModalClose}
            maxWidth='sm'
            fullWidth
            {...modalProps}>
            <>

                <form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading && (
                        <ModalLoader />
                    )}
                    <DialogTitle className='brandAddModal--DialogTitle'>
                        <Typography type='s3' color='inherit' weight='medium'>
                            {t("inventory.item.locationModal.title")}
                        </Typography>
                        <IconButton onClick={handleModalClose}>
                            <Close fontSize='small' />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent className='brandAddModal--DialogContents'>

                        <Grid container rowGap={1.5} columnSpacing={3} pt={3}>
                            <Grid item sm={6}>
                                <DynamicInput
                                    type='text'
                                    formControl={control}
                                    label={t("inventory.item.locationModal.location_name_label")}
                                    name='name'
                                    fieldArrayName='location_data'
                                    placeholder={t("inventory.item.locationModal.location_name_placeholder")}
                                    required
                                />
                            </Grid>
                            <Grid item sm={6}>
                                <DynamicInput
                                    type='text'
                                    formControl={control}
                                    label={t("inventory.item.locationModal.location_code_label")}
                                    name='short_name'
                                    fieldArrayName='location_data'
                                    placeholder={t("inventory.item.locationModal.location_code_placeholder")}
                                    required
                                />
                            </Grid>
                            <Grid item sm={6}>
                                <DynamicSearchSelect
                                    label={t(
                                        "accounting.authorize_commission.fields.company_label"
                                    )}
                                    name="company_id"
                                    placeholder={t(
                                        "accounting.authorize_commission.fields.company_placeholder"
                                    )}
                                    fieldArrayName='location_data'
                                    formControl={control}
                                    apiType='company'
                                    getSelectedData={(data: any) =>
                                        // setSelectedData(name, data)
                                        console.log("data", data)
                                    }
                                    required={true}
                                />
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions className='brandAddModal--DialogAction'>
                        <span></span>
                        <Box display='flex' gap={1.5}>
                            <Button
                                className='brandAddModal--DialogAction--WhiteBtn'
                                onClick={handleModalClose}>
                                {t("common.cancel")}
                            </Button>
                            <Button type='button' onClick={handleSubmit(onSubmit)}>{t("common.save")}</Button>
                        </Box>
                    </DialogActions>
                </form>
            </>
            <Toast
                open={Boolean(toast)}
                type={toast?.type}
                message={toast?.message}
                handleClose={() => setToast(null)}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            />
        </Modal>
    );
};

export default LocationAddModal;
